export default "__VITE_ASSET__WlMgPNj4__"